import { PatronLocationEntity } from 'components/patron-location/PatronLocation';
import AppConstants from 'constants/AppConstants';

export function updatePatronLocationHistory(
  patronLocationHistory: PatronLocationEntity[]
): BaseTockAction<PatronLocationEntity[]> {
  return {
    type: AppConstants.PATRON_LOCATION_HISTORY_UPDATED,
    payload: patronLocationHistory,
  };
}
